import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { OrdoclicIframe } from './OrdoclicIframe.component'

const withUnmountHoc = withUnmountTransition(OrdoclicIframe)
export { withUnmountHoc as OrdoclicIframe }
